import loader from './loader.png';

import styles from './Loader.module.scss';

const Loader = () => {
  return (
    <div className={styles.loader}>
      <img src={loader} alt="Loading MonitorMonk" />
    </div>
  );
};

export default Loader;
